/* script */
//
//
//
//
//
//
//
//
//
//

/**
 * Use this component to show an undeterminate loading process.
 *
 * @vue-prop {Boolean} status whether the loading is on-going or not.
 * @vue-prop {String} [scope='page'] a unique string that specifies the context of the loader.
 *
 * @example
 * loader(:status="loading")
 *    div
 *        p my content
 *
 * @category ui.components
 * @exports Loader
 * @component
 */
const __vue_script__ = {
    name: 'Loader',

    props: {
        status: {
            type: Boolean,
            required: true
        },
        scope: {
            type: String,
            default: 'page'
        },
        caption: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            loading: this.status,
            animate: this.status
        };
    },

    computed: {
        /**
         * Whether the component has default slot defined or not
         *
         * @returns {Boolean} true if it has a default slot
         */
        hasDefaultSlot() {
            return !!this.$slots.default;
        }
    },

    watch: {
        status(status) {
            this.loading = status;
            if (status) {
                this.animate = true;
            } else {
                // Wait 1s before remove the animation.
                // We set this timeout to avoid animation glitches.
                // Without this timeout, the loader stops spinning
                // before disappearing, which is not the desired result.
                setTimeout(() => (this.animate = false), 1000);
            }
        }
    },

    created() {
        // We put a listener on the root node in order to have
        // control over every loader
        this.$root.$on('loading', (loading, scope = 'page') => {
            if (this.scope === scope || scope === 'global') {
                this.loading = !!loading;
            }
        });
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[(_vm.animate)?_c('div',{staticClass:"loading",class:[_vm.loading ? 'in' : '']},[_c('div',{staticClass:"spinner",class:[_vm.animate ? 'animated' : '']}),(_vm.caption)?_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))]):_vm._e()]):_vm._e(),(_vm.hasDefaultSlot)?_c('div',{staticClass:"loaded",class:[_vm.loading ? '' : 'in']},[_vm._t("default")],2):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Loader.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__